/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const MinPasswordScoreSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('MIN_PASSWORD_SCORE')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
]);
export class MinPasswordScoreSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return MinPasswordScoreSettingParser.decode(input).map(res => new MinPasswordScoreSetting(res));
    }
    static unsafeDecode(input) {
        return MinPasswordScoreSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return MinPasswordScoreSettingParser.encode(data);
    }
    static schema() {
        return MinPasswordScoreSettingParser.schema();
    }
}
